<template>
  <div class="fillcontain">
    <search-item @showDialog="showAddSchoolDialog"></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        align="center"
        @select="selectTable"
        @select-all="selectAll"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          width="100"
          prop="id"
          label="id"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="schoolName"
          label="校区名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="address"
          label="校区地址"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="isShow"
          label="是否展示在小程序"
          align="left"
          :filters="fields.isShow.filter.list"
          :filter-method="filterIsShow"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterIsShow(scope.row)"
              :type="scope.row.isShow === 0 ? 'warning' : 'success'"
              disable-transitions
              >{{ scope.row.isShow }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="edit"
              size="mini"
              @click="onEditAppointmenttype(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="delete"
              size="mini"
              @click="onDeleteSchoolInfo(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <addFundDialog
        v-if="addSchoolDialog.show"
        :isShow="addSchoolDialog.show"
        :dialogRow="addSchoolDialog.dialogRow"
        @getAppointmenttypeList="getSchoolInfo"
        @closeDialog="hideAddFundDialog"
      ></addFundDialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as mutils from "@/utils/mUtils";
import SearchItem from "./components/searchItem";
import AddFundDialog from "./components/addCourseDialog";
import Pagination from "@/components/pagination";
import { myTime, formatDateTime, formatDateTime1 } from "../../utils/date.js";
import { getSchoolInfo, deleteSchool } from "@/api/school";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  data() {
    return {
      tableData: [],
      tableHeight: 0,
      loading: false,
      idFlag: false,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      multipleSelection: [], //多选的数据
      sortnum: 0,
      addSchoolDialog: {
        show: false,
        dialogRow: {},
      },
      schoolData: {
        page: 1,
        limit: 20,
      },
      format_isshow_list: {
        0: "否",
        1: "是",
      },
      fields: {
        isShow: {
          filter: {
            list: [
              {
                text: "否",
                value: 0,
              },
              {
                text: "是",
                value: 1,
              },
            ],
          },
        },
      },
      pageTotal: 0,
    };
  },
  filters: {
    filterTime(time) {
      return formatDateTime(time);
    },
    filterTime1(time) {
      var dd = myTime(time);
      return formatDateTime1(dd);
    },
  },
  components: {
    SearchItem,
    AddFundDialog,
    Pagination,
  },
  computed: {
    ...mapGetters(["courseSearch"]),
  },
  mounted() {
    this.getSchoolInfo();
  },
  methods: {
    filterIsShow(value, item) {
      const type = parseInt(item.isShow);
      return this.format_isshow_list[value] == this.format_isshow_list[type];
    },
    /**
     * 格式化状态
     */
    formatterIsShow(item) {
      const type = parseInt(item.isShow);
      return this.format_isshow_list[type];
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    //获取预约类型列表
    getSchoolInfo() {
      const para = this.schoolData;
      getSchoolInfo(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.total;
        this.tableData = res.data.data.schoolList;
      });
    },
    // 显示添加预约类型弹窗
    showAddSchoolDialog(val) {
      this.$store.commit("SET_SCHOOL_DIALOG_TITLE", val);
      this.addSchoolDialog.show = true;
    },
    hideAddFundDialog() {
      this.addSchoolDialog.show = false;
      // this.getSchoolInfo();
    },
    // 上下分页
    handleCurrentChange(val) {
      this.schoolData.page = val;
      this.getSchoolInfo();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.schoolData.limit = val;
      this.getSchoolInfo();
    },
    // 编辑操作方法
    onEditAppointmenttype(row) {
      console.log(row);
      // var para = {}
      var param = Object.assign({}, row);
      this.addSchoolDialog.dialogRow = {
        param,
      };
      this.showAddSchoolDialog();
    },
    // 删除数据
    onDeleteSchoolInfo(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteSchool({ id: row.id }).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            const para = {
              userName: getToken("USERNAME"),
              content: "删除(" + row.schoolName + ")校区操作",
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            this.getSchoolInfo();
          });
        })
        .catch(() => {});
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    selectTable(val, row) {
      this.setSearchBtn(val);
    },
    // 用户全选checkbox时触发该事件
    selectAll(val) {
      this.setSearchBtn(val);
    },
    setSearchBtn(val) {
      let isFlag = true;
      if (val.length > 0) {
        isFlag = false;
      } else {
        isFlag = true;
      }
      this.$store.commit("SET_COURSE_SEARCHBTN_DISABLED", isFlag);
    },
  },
};
</script>

<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>


